if ($('.fixed-rrss') && $('.fixed-rrss').length > 0) {
    var lastScrollTop = 0;
    $(window).on('scroll', function() {
        var scrollTop = $(this).scrollTop();

        if (scrollTop > lastScrollTop) {
            $('.fixed-rrss').addClass('s-hidden');
        }
        else if (scrollTop < lastScrollTop) {
            $('.fixed-rrss').removeClass('s-hidden');
        }

        lastScrollTop = scrollTop;
    }).load(function() {
        setTimeout(function() {
            $('.fixed-rrss').addClass('s-hidden');
        }, 3000);
    });
}